(function () {
  'use strict';
  var dialog = document.querySelector('[data-ft-order-entry]');
  if (!dialog) return;
  var design = null;
  var opener = null;
  window.FTOrderEntry = {
    open: function (url, prompt) {
      design = url ? { url: url, prompt: prompt || '', ts: Date.now() } : null;
      opener = document.activeElement;
      dialog.querySelector('[data-ft-entry-design]').textContent = 'Your AI design is ready. Choose a garment, then a print location to add it.';
      dialog.querySelector('[data-ft-entry-design]').hidden = !design;
      if (!dialog.open) dialog.showModal();
    }
  };
  dialog.querySelector('[data-ft-entry-close]').addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('close', function () { if (opener && opener.focus) opener.focus(); });
  dialog.addEventListener('click', function (event) {
    if (!event.target.closest('[data-ft-entry-product]')) return;
    try {
      if (design) sessionStorage.setItem('ai_design_pending', JSON.stringify(design));
      else sessionStorage.removeItem('ai_design_pending');
    } catch (_) {
      if (design) {
        event.preventDefault();
        dialog.querySelector('[data-ft-entry-design]').textContent = 'Your browser could not carry this design to the product. Download it from the designer, then upload it on the product page.';
      }
    }
  });
}());
